import React from 'react';

import LinkCard from '../../../display/components/LinkCard';
import PartyPill from '../../../display/components/PartyPill';
import HeadingTag from '../../../display/components/HeadingTag';

interface ICardProps {
  imageUrl: string;
  name: string;
  party: string;
  title: string;
  url: string;
}

const Card: React.FC<ICardProps> = ({ imageUrl, name, party, title, url }) => (
  <div className="c-directory-card">
    <LinkCard
      url={url}
      urlText={`More about ${name}`}
      ga={{
        action: '',
        category: '',
        label: '',
      }}
    >
      <div className="c-directory-card__grid">
        <header className="c-directory-card__header l-align-center-self">
          <div className="has-tiny-btm-marg">
            <HeadingTag
              level={4}
              display={{ cssClasses: ['l-display-ib', 't-size-m'] }}
            >
              {name}
            </HeadingTag>{' '}
            <PartyPill party={party} />
          </div>
          <p>{title}</p>
        </header>
        <div className="c-directory-card__img">
          <img
            src={imageUrl}
            alt={`${name} portrait`}
            className="l-display-block l-width-full is-rounded-full"
          />
        </div>
      </div>
    </LinkCard>
  </div>
);

export default Card;
